import { memo } from 'react';

import { SysadminClearWorkspaceButton, useSysadmin } from '@air/sysadmin';

import { AccountButton } from '~/components/Layouts/HomeLayout/SideNav/AccountButton';
import { WorkspaceNav } from '~/components/Layouts/HomeLayout/SideNav/WorkspaceNav';
import { HelpButton } from '~/components/MainNavigation/HelpButton';
import { WORKSPACE_NAV_WIDTH } from '~/constants/sideNav';
import { MAIN_NAVIGATION } from '~/constants/testIDs';

export const MainNavigation = memo(() => {
  const { isInternal } = useSysadmin();

  return (
    <div
      className="flex flex-col justify-between border-r ads:border-r-default border-r-gray-4 ads:bg-raised bg-gray-2"
      data-testid={MAIN_NAVIGATION}
      style={{ width: WORKSPACE_NAV_WIDTH }}
    >
      {isInternal && (
        <div className="flex items-center justify-center pt-5">
          <SysadminClearWorkspaceButton />
        </div>
      )}

      <div className="flex-1 overflow-hidden">
        <WorkspaceNav />
      </div>
      <div className="flex flex-col items-center gap-3 pb-2">
        <HelpButton />
        <AccountButton />
      </div>
    </div>
  );
});

MainNavigation.displayName = 'MainNavigation';
